import React, { useContext } from 'react';
import DealerPriceInfo from '../DealerPriceInfo/DealerPriceInfo';
import { VehicleDetails } from '../../types';
import { vehicleContext } from '../VehicleProvider';
import { Container, CTAWrapper } from './DealerListPrice.styles';
import { CTAContext } from '../CTAProvider';
import VinAudiCode from '../VinAudiCode';
import CTASection from '../CTASection';
import { IS_T3_WEBSITE } from '../../constants/environment';
import VendorCTAsGroup from '../VendorCTAsGroup/VendorCTAsGroup';

const DealerListPrice: React.FC = () => {
  const { vehicle } = useContext(vehicleContext);
  const { audiCode, vin, id, market, modelMake } = (vehicle as VehicleDetails) ?? {};
  const { tier3Ctas } = useContext(CTAContext);
  const { vendorCtaGroup } = tier3Ctas;

  if (!vehicle) return null;

  return (
    <>
      <Container data-testid="dealer-list-price-container">
        <DealerPriceInfo />
        <CTAWrapper>
          <VinAudiCode vin={vin} audiCode={audiCode} modelMake={modelMake} />
          {IS_T3_WEBSITE ? (
            <VendorCTAsGroup
              ctas={vendorCtaGroup}
              vin={vin}
              vehicleId={id}
              market={market}
              vehicleData={vehicle}
            />
          ) : (
            <CTASection isSticky={false} />
          )}
        </CTAWrapper>
      </Container>
    </>
  );
};

export default DealerListPrice;
